import { useState, useEffect } from 'react';
import NotificationIcons from './NotificationIcons';

const reportStatuses = [
  { 
    label: 'TappyKash', 
    icon: '/img/transaction.svg', 
    value: 'tappykash'
  },
  { 
    label: 'Payment Verification', 
    icon: '/img/profit-and-loss.svg', 
    value: 'payment_verification'
  },
  { 
    label: 'Voucher', 
    icon: '/img/voucher.svg', 
    value: 'voucher'
  },
  { 
    label: 'eWallet', 
    icon: '/img/wallet copy 2.svg', 
    value: 'ewallet'
  },
  { 
    label: 'CSV', 
    icon: '/img/csv.svg', 
    value: 'csv'
  },
];

export default function ReportTabs({ 
  selected, 
  onSelect,
  selectedSubStatus,
  onSubStatusSelect
}: {
  selected?: string;
  onSelect?: (status: string) => void;
  selectedSubStatus?: string;
  onSubStatusSelect?: (subStatus: string) => void;
}) {
  const [activeStatus, setActiveStatus] = useState(selected || 'tappykash');
  const [activeSubStatus, setActiveSubStatus] = useState(selectedSubStatus || 'capture');

  useEffect(() => {
    if (selected) {
      setActiveStatus(selected);
    }
  }, [selected]);

  useEffect(() => {
    if (selectedSubStatus) {
      setActiveSubStatus(selectedSubStatus);
    }
  }, [selectedSubStatus]);

  const handleStatusClick = (statusValue: string) => {
    setActiveStatus(statusValue);
    onSelect?.(statusValue);

    if (statusValue === 'tappykash') {
      setActiveSubStatus('capture');
      onSubStatusSelect?.('capture');
    } else if (statusValue === 'voucher') {
      setActiveSubStatus('unassign');
      onSubStatusSelect?.('unassign');
    }
  };

  const handleSubStatusClick = (subStatusValue: string) => {
    setActiveSubStatus(subStatusValue);
    onSubStatusSelect?.(subStatusValue);
  };

  return (
    <div className="space-y-4">
      {/* Main Status Tabs */}
      <div className="flex justify-between items-center mb-6 mt-[-24px] overflow-x-auto py-3 bg-gray-200 px-8 outline outline-1 outline-gray-200 relative z-10">
        <div className="flex gap-3">
          {reportStatuses.map((status) => {
            const isSelected = activeStatus === status.value;
            return (
              <button
                key={status.value}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer
                  ${isSelected ? 'text-primary-500' : 'text-gray-600 hover:text-primary-500/40'}
                `}
                onClick={() => handleStatusClick(status.value)}
              >
                <div className={`w-11 h-11 rounded-lg flex items-center justify-center transition-colors ${
                  isSelected ? 'bg-primary-500' : 'bg-white hover:bg-gray-50'
                }`}>
                  <img
                    src={status.icon}
                    alt={status.label}
                    className="w-6 h-6"
                  />
                </div>
                <span>
                  {status.label === 'Payment Verification' ? (
                    <>Payment<br />Verification</>
                  ) : (
                    status.label
                  )}
                </span>
              </button>
            );
          })}
        </div>

        {/* Notification Icons */}
        <NotificationIcons />
      </div>

      {/* TappyKash sub-tabs */}
      {activeStatus === 'tappykash' && (
        <div className="px-8 mt-4 relative z-0">
          <div className="flex mt-[-30px] mb-8 ml-[13px] w-fit relative z-0">
            {[
              { label: 'Capture', value: 'capture' },
              { label: 'Report', value: 'report' }
            ].map((tab, index) => {
              const isSelected = activeSubStatus === tab.value;
              const overlapClass = index === 0 ? '' : '-ml-6';
              return (
                <button
                  key={tab.value}
                  className={`${overlapClass} px-8 py-2.5 first:pl-7 last:pr-7 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center rounded-full border relative
                    ${isSelected
                      ? 'bg-[#FFF8D6] text-[#D4A017] font-semibold border-[#F2BC00]'
                      : 'bg-white text-[#1E3255] border-[#4B5675] hover:bg-[#F7F9FC]'
                    }
                  `}
                  style={{ zIndex: 20 - index }}
                  onClick={() => handleSubStatusClick(tab.value)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Voucher sub-tabs */}
      {activeStatus === 'voucher' && (
        <div className="px-8 mt-4 relative z-0">
          <div className="flex mt-[-30px] mb-8 ml-[13px] w-fit relative z-0">
            {[
              { label: 'Unassign', value: 'unassign' },
              { label: 'Topup', value: 'topup' },
              { label: 'Transactions', value: 'transactions' }
            ].map((tab, index) => {
              const isSelected = activeSubStatus === tab.value;
              const overlapClass = index === 0 ? '' : '-ml-6';
              return (
                <button
                  key={tab.value}
                  className={`${overlapClass} px-8 py-2.5 first:pl-7 last:pr-7 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center rounded-full border relative
                    ${isSelected
                      ? 'bg-[#FFF8D6] text-[#D4A017] font-semibold border-[#F2BC00]'
                      : 'bg-white text-[#1E3255] border-[#4B5675] hover:bg-[#F7F9FC]'
                    }
                  `}
                  style={{ zIndex: 20 - index }}
                  onClick={() => handleSubStatusClick(tab.value)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
